export const Colors = {
  primary: "#E79A3F",
  grayText: "#374151",
  ash: "#9CA3AF",
  modernBlack: "#E5E7EB",
  modernBlack08: "#374151",
};